// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponsePropagation
 */
export interface ResponsePropagation {
  /**
   *
   * @type {number}
   * @memberof ResponsePropagation
   */
  attempts?: number;
  /**
   *
   * @type {number}
   * @memberof ResponsePropagation
   */
  lastAppliedActionId?: number;
  /**
   *
   * @type {string}
   * @memberof ResponsePropagation
   */
  lastError?: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePropagation
   */
  nextAttemptAt?: string;
}

/**
 * Check if a given object implements the ResponsePropagation interface.
 */
export function instanceOfResponsePropagation(
  value: object,
): value is ResponsePropagation {
  return true;
}

export function ResponsePropagationFromJSON(json: any): ResponsePropagation {
  return ResponsePropagationFromJSONTyped(json, false);
}

export function ResponsePropagationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponsePropagation {
  if (json == null) {
    return json;
  }
  return {
    attempts: json['attempts'] == null ? undefined : json['attempts'],
    lastAppliedActionId:
      json['lastAppliedActionId'] == null
        ? undefined
        : json['lastAppliedActionId'],
    lastError: json['lastError'] == null ? undefined : json['lastError'],
    nextAttemptAt:
      json['nextAttemptAt'] == null ? undefined : json['nextAttemptAt'],
  };
}

export function ResponsePropagationToJSON(json: any): ResponsePropagation {
  return ResponsePropagationToJSONTyped(json, false);
}

export function ResponsePropagationToJSONTyped(
  value?: ResponsePropagation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    attempts: value['attempts'],
    lastAppliedActionId: value['lastAppliedActionId'],
    lastError: value['lastError'],
    nextAttemptAt: value['nextAttemptAt'],
  };
}
